
import { Link } from 'react-router-dom';
import { MagnifyingGlassIcon, BookOpenIcon, VideoCameraIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const SupportHero = () => {
  return (
    <section className="bg-gradient-to-b from-primary/10 to-background py-20">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-5xl font-bold text-foreground mb-6">
          How Can We <span className="text-primary">Help You Thrive</span>?
        </h1>
        <p className="text-xl text-muted-foreground mb-12 max-w-3xl mx-auto">
          Whether you're an older adult taking charge of your independence, a family member supporting 
          a loved one, a dedicated caregiver, or a generous sponsor, we're here to make your success inevitable.
        </p>
        
        <div className="grid md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="bg-card border rounded-lg p-6 hover:shadow-lg transition-shadow">
            <BookOpenIcon className="h-8 w-8 text-primary mx-auto mb-4" />
            <h3 className="font-semibold text-foreground mb-2">Guides & How-Tos</h3>
            <p className="text-sm text-muted-foreground">Step-by-step instructions for every feature</p>
          </div>
          <Link 
            to="/support/faq"
            className="bg-card border rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer group"
          >
            <QuestionMarkCircleIcon className="h-8 w-8 text-primary mx-auto mb-4 group-hover:scale-110 transition-transform" />
            <h3 className="font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">Frequently Asked</h3>
            <p className="text-sm text-muted-foreground">Quick answers to common questions</p>
          </Link>
          <div className="bg-card border rounded-lg p-6 hover:shadow-lg transition-shadow">
            <VideoCameraIcon className="h-8 w-8 text-primary mx-auto mb-4" />
            <h3 className="font-semibold text-foreground mb-2">Video Tutorials</h3>
            <p className="text-sm text-muted-foreground">Visual demonstrations and tips</p>
          </div>
          <div className="bg-card border rounded-lg p-6 hover:shadow-lg transition-shadow">
            <MagnifyingGlassIcon className="h-8 w-8 text-primary mx-auto mb-4" />
            <h3 className="font-semibold text-foreground mb-2">Smart Search</h3>
            <p className="text-sm text-muted-foreground">Find exactly what you're looking for</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportHero;
